// Suppress YouTube analytics/logging errors that are blocked by ad blockers
// These errors are harmless and don't affect video playback

if (typeof window !== 'undefined') {
  // List of YouTube error patterns to suppress
  const shouldSuppressError = (message) => {
    if (!message) return false;
    const errorStr = String(message).toLowerCase();
    return (
      errorStr.includes('err_blocked_by_client') ||
      errorStr.includes('youtubei/v1/log_event') ||
      errorStr.includes('youtube.com/youtubei/v1/log_event') ||
      errorStr.includes('generate_204') ||
      errorStr.includes('youtube.com/generate_204') ||
      (errorStr.includes('failed to load resource') && errorStr.includes('youtube.com')) ||
      (errorStr.includes('net::err_blocked_by_client') && errorStr.includes('youtube'))
    );
  };

  // Suppress console.error calls
  const originalError = console.error;
  console.error = function(...args) {
    const message = args.join(' ');
    if (shouldSuppressError(message)) {
      // Silently ignore these errors - they're from ad blockers blocking YouTube analytics
      return;
    }
    // Log all other errors normally
    originalError.apply(console, args);
  };

  // Suppress console.warn for YouTube errors
  const originalWarn = console.warn;
  console.warn = function(...args) {
    const message = args.join(' ');
    if (shouldSuppressError(message)) {
      return;
    }
    originalWarn.apply(console, args);
  };

  // Suppress global error events (catches network errors)
  window.addEventListener('error', (event) => {
    const errorMessage = event.message || event.filename || '';
    if (shouldSuppressError(errorMessage)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true); // Use capture phase to catch early

  // Suppress unhandled promise rejections from YouTube
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (reason) {
      const errorMessage = reason.message || reason.toString() || '';
      if (shouldSuppressError(errorMessage)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }
  }, true);

  // Intercept fetch requests to suppress errors (if needed)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).catch((error) => {
      const url = args[0]?.toString() || '';
      if (shouldSuppressError(url)) {
        // Return a mock response to prevent error propagation
        return Promise.resolve(new Response(null, { status: 0 }));
      }
      throw error;
    });
  };

  // Suppress XMLHttpRequest errors for YouTube analytics
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    if (shouldSuppressError(url)) {
      // Override send to prevent actual request
      this.send = function() {
        // Silently fail
        if (this.onerror) {
          setTimeout(() => this.onerror(new Error('Blocked by client')), 0);
        }
      };
    }
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };
}

